/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React, { useContext, useState, useCallback, useMemo, useEffect } from 'react';

import * as AppPropTypes from '../lib/PropTypes';

import { useApi } from './ApiContext';
import { useUser } from './AuthContext';

const PurchasesContext = React.createContext(null);

const usePurchasesContext = () => useContext(PurchasesContext);

export const usePurchaseItems = () => {
    const { purchases } = usePurchasesContext();
    return purchases;
};

export const useSetPurchases = () => {
    const { setPurchases } = usePurchasesContext();
    return setPurchases;
};

export const usePurchasesByType = (type) => {
    const purchases = usePurchaseItems();
    return (purchases || []).filter((it) => it.type === type);
};

export const getPurchaseByProduct = (parentProduct) => {
    const { id: productId = null, type: productType = null } = parentProduct || {};
    const purchases = usePurchaseItems();
    const items = (purchases || []).filter(
        ({ product = null }) =>
            product !== null && product.type === productType && product.id === productId,
    );
    return items.length > 0 ? items[0] : null;
};

export const getPurchaseByFilm = (film) => {
    const { id: filmId = null } = film || {};
    const purchases = usePurchaseItems();
    const items = (purchases || []).filter(({ item = null }) => {
        const { film: purchasedFilm = null } = item || {};
        const { id: purchasedFilmId = null } = purchasedFilm || {};
        return purchasedFilmId === filmId;
    });
    return items.length > 0 ? items[0] : null;
};

export const useAddPurchase = () => {
    const setPurchases = useSetPurchases();
    const purchases = usePurchaseItems();
    return useCallback(
        (purchase) => {
            if (purchase !== null) {
                setPurchases([
                    ...(purchases || []).filter((it) => it.id !== purchase.id),
                    purchase,
                ]);
            }
        },
        [purchases, setPurchases],
    );
};

const propTypes = {
    purchases: AppPropTypes.purchases,
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    purchases: null,
};

export const PurchasesProvider = ({ purchases: initialPurchases, children }) => {
    const [purchases, setPurchases] = useState(initialPurchases);
    const api = useApi();
    const user = useUser();
    const { id = null } = user || {};

    useEffect(() => {
        if (user !== null && initialPurchases === null) {
            // TODO: enable this for online purchases
            // api.purchases.get().then((response) => {
            //     setPurchases(response);
            // });
        }
    }, [initialPurchases, api, id, setPurchases]);

    // useEffect(() => {
    //     if (user !== null) {
    //         setPurchases(null);
    //     }
    // }, [setPurchases]);

    const value = useMemo(
        () => ({
            purchases,
            setPurchases,
        }),
        [purchases, setPurchases],
    );
    return <PurchasesContext.Provider value={value}>{children}</PurchasesContext.Provider>;
};

PurchasesProvider.propTypes = propTypes;
PurchasesProvider.defaultProps = defaultProps;

export default PurchasesContext;
